import React from 'react';
import  './Pages.css';
import { useState, useRef, useContext } from 'react';
import { Link } from 'react-router-dom';
import Characters from '../Components/Characters';
import Results from '../Components/Results';
import Timer from '../Components/Timer';
import { BsArrowLeft } from "react-icons/bs";
import handleWordType from '../Functions/handleWordType';
import handleReset from '../Functions/handleReset';
import { practiceparagraphs } from '../Components/Paragraphs';
import { ResultsContext } from '../Store/ResultsContext';
import { useSaveResultEffect, useTimerEffect, useKeyDownEffect, useFocusEffect } from '../Functions/useEffects';

const TimeSelector = ({ onTimeChange }) => {
  return (
    <div className="time-selector"> <h6>Set test time to : </h6>
      <button  className="button" onClick={() => onTimeChange(30)}>30 Sec</button>
      <button  className="button" onClick={() => onTimeChange(60)}>60 Sec</button>
      <button  className="button" onClick={() => onTimeChange(120)}>2 Minutes</button>
      <button  className="button" onClick={() => onTimeChange(180)}>3 Minutes</button>
    </div>
  );
};

const TimeAttack = () => {
  const defaultTime = 60;

  const [para, setPara] = useState(practiceparagraphs[Math.floor(Math.random() * practiceparagraphs.length)]);
  const [word, setWord] = useState('');
  const [chrIndex, setChrIndex] = useState(0);
  const [time, setTime] = useState(defaultTime);
  const [maxTime, setMaxTime] = useState(defaultTime);
  const [mstk, setMstk] = useState(0);
  const [WPM, setWPM] = useState(0);
  const [CPM, setCPM] = useState(0);
  const [acc, setAcc] = useState(0);
  const [misPenal, setMisPenal] = useState(0);
  const [spScore, setspScore] = useState(0);
  const [points, setPoints] = useState(0);

  const totalChars = useRef(0);
  const totalCorrChars = useRef(0);
  const timer = useRef();
  const inputRef = useRef(null);

  const { addResult } = useContext(ResultsContext);

  const handleTryAgain = (e) => {
    if (time > 0) return;
    handleReset(setWord, setChrIndex, setTime, setMstk, setWPM, setCPM, setAcc, setspScore, setMisPenal, timer, totalChars, totalCorrChars, maxTime);
    setPara(practiceparagraphs[Math.floor(Math.random() * practiceparagraphs.length)]);
  };

//all use effects
useSaveResultEffect(time, addResult, WPM, CPM, mstk, acc, spScore, misPenal, points);
useTimerEffect(time, timer, setTime);
useKeyDownEffect(inputRef);
useFocusEffect(inputRef);

  const handleRestart = () => {
    setPara(practiceparagraphs[Math.floor(Math.random() * practiceparagraphs.length)]);
    handleReset(setWord, setChrIndex, setTime, setMstk, setWPM, setCPM, setAcc, setspScore, setMisPenal, timer, totalChars, totalCorrChars, maxTime);
  };

  const handleTimeChange = (newMaxTime) => {
    setMaxTime(newMaxTime);
    setTime(newMaxTime);
  };

  return (
    <>
      <div className="bg-ctr">
        <div className="backflex">
        <div className="go-back"> <Link to="/explore" style={{color:"white"}}><BsArrowLeft />
        </Link></div>    
        <TimeSelector onTimeChange={handleTimeChange} />
        </div>
        <div className="timerbox">
          <Timer time={time} tryAgainEv={handleTryAgain} />
        </div>
        {time <= 0 && (
          <Results
            WPM={WPM}
            CPM={CPM}
            mstk={mstk}
            acc={acc}
            spScore={spScore}
            misPenal={misPenal}
            points={points}
          />
        )}
        <input
          type="text"
          value={word}
          autoFocus
          onChange={(e) => handleWordType(e, para, time, setWord, setChrIndex, setMstk, setCPM, setWPM, setspScore, setMisPenal, setPoints, maxTime, timer, setTime, chrIndex, totalChars, totalCorrChars, setAcc)}
          ref={inputRef}
          style={{ opacity: 0 }}
        />
        <Characters para={para} time={time} word={word} chrIndex={chrIndex} handleRestart={handleRestart} />
      </div>
    </>
  );
}

export default TimeAttack;
